import React             from 'react';
import Dialog            from '@mui/material/Dialog';
import DialogTitle       from '@mui/material/DialogTitle';
import DialogContent     from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions     from '@mui/material/DialogActions';
import {connect}         from 'react-redux';
import DeleteIcon        from '@mui/icons-material/Delete';
import Typography        from '@mui/material/Typography';
import {useTranslation}               from 'react-i18next';
import Button                         from '../../../../inputs/Button';
import {deleteComment, fetchComments} from '../../../../../../store/actions/SocialAction';


const DeleteDialog = ({comment, open, setOpen, deleting, deleteComment, refresh}) => {
	const {t} = useTranslation();

	const handleClose = () => {
		setOpen(false);
	};

	const handleDelete = () => {
		deleteComment(comment.Social_Comment__)
			.then(refresh)
			.then(handleClose);
	};

	return (
		<Dialog
			open={open}
			aria-labelledby="Delete comment"
			aria-describedby="Delete comment"
			fullWidth
		>
			<DialogTitle id="comment-delete-title">{t('confirm_delete_comment_title')}</DialogTitle>
			<DialogContent>
				<DialogContentText id="comment-delete-description">
					{t('confirm_delete_comment_desc')}
					<br/>
					<Typography variant="body1" color="textPrimary" component="span">{t('are_you_sure')}</Typography>
				</DialogContentText>
			</DialogContent>

			<DialogActions>
				<Button variant="contained" color="primary" autoFocus onClick={handleClose} disabled={deleting}>
					{t('back_btn')}
				</Button>
				<Button color="secondary" loading={deleting} disabled={deleting} endIcon={<DeleteIcon/>}
				        onClick={handleDelete}>
					{t('delete_btn')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

const mapStateToProps = (state) => {
	return {
		deleting: state.social.commentDeleting
	};
};

const mapDispatchToProps = (dispatch, props) => {
	return {
		deleteComment: (commentId) => dispatch(deleteComment(commentId)),
		refresh: () => dispatch(fetchComments()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDialog);
